import { connect } from 'react-redux';

import ThankYouModal from './thank-you-modal';

import { closeModal } from '../../reducers/offer';

export default connect((state) => state, {
  closeModal,
})(ThankYouModal);
